import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CompanyService } from 'app/company/services/company.service';
import { SharedService } from 'app/shared/services/shared.service';
import { User } from 'app/shared/models/User';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CompanyDetailsModel } from 'app/company/models/company-details-model';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { Location, DatePipe } from '@angular/common';
import { CompanyTypeModel } from 'app/company/models/company-type-model';
import { CompanyListModel } from 'app/company/models/company-list.model';
import { AggregatorModel } from 'app/company/models/aggregator-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuditTargetModel } from '../../models/audit-target.model';
import { AuditTargetTimeframeCategoryModel } from '../../models/audit-target-timeframe-category.model';

@Component({
  selector: 'app-audit-targets',
  templateUrl: './audit-targets.component.html',
  styleUrls: ['./audit-targets.component.css']
})
export class AuditTargetsComponent implements OnInit {
    user: User;
    isAdmin: boolean = false;
    auditTargetModel: AuditTargetModel;
    errors: string[];
    headerTitle: IHeaderTitle;
    submitAttempt = false;
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;
    redirectRoutes: Routes;
    auditTargetsFormGroup: FormGroup;
    isEditMode = false;
    @Input() companyId: string;
    auditTargetCategoryList: AuditTargetTimeframeCategoryModel[];
    companyAuditTargetList: AuditTargetModel[];
    companyAuditTarget: AuditTargetModel;
    selectedTargetCategory: string;

    constructor(
        private companyService: CompanyService,
        private sharedService: SharedService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        private location: Location,
        private router: Router,
        private datePipe: DatePipe,
        private modalService: NgbModal) { }

    ngOnInit() {

        this.sharedService.currentUser.subscribe(user => {
            this.user = user;
            this.isAdmin = this.user.isAdmin;
        });

        this.load();
    }

    load(): void {
        //this.companyId = this.activatedRoute.snapshot.params['id'];

        this.companyService.get(this.companyId).subscribe(companyInfo => {

            if (this.isAdmin) {
                this.headerTitle = {
                    title: companyInfo.legalName,
                    breadcrumbs: [{ title: 'Companies', url: ['/company'] }]
                };
            } else {
                this.headerTitle = {
                    title: companyInfo.legalName
                };
            }

            this.companyService.getAuditTimeframeCategories().subscribe(
                result => {
                    this.auditTargetCategoryList = result;
                    this.loadCompanyAuditTargets();
                },
                error => {
                    this.errors = error.errorList;
                }
            );




        });

    }

    loadCompanyAuditTargets(): void {
        this.companyService.getCompanyAuditTargets(this.companyId).subscribe(
            result => {
                this.companyAuditTargetList = result;
                // SQL SPs can handle multiple targets, this component only allows one for now.
                if (result.length > 0) {
                    this.companyAuditTarget = result[0];
                    this.selectedTargetCategory = this.auditTargetCategoryList.filter(x => x.id === result[0].auditTargetTimeframeCategoryId)[0].description;
                    this.initializeForm(this.companyAuditTarget);
                } else {
                    this.companyAuditTarget = {
                        id: null,
                        companyId: this.companyId,
                        auditCategoryId: 1,
                        auditTargetTimeframeCategoryId: 1,
                        threshold: 1,
                        isActive: true
                    }
                    this.initializeForm(this.companyAuditTarget);
                }

            },
            error => {
                this.errors = error.errorList;
            }
        );
    }

    initializeForm(model: AuditTargetModel): void {
        this.auditTargetsFormGroup = this.fb.group(
            {
                id: [model.id],
                companyId: [model.companyId],
                auditCategoryId: [model.auditCategoryId],
                auditTargetTimeframeCategoryId: [model.auditTargetTimeframeCategoryId],
                threshold: [model.threshold],
                isActive: [model.isActive]
            }
        );

    }

    successClicked($event: any): void {
        this.load();
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    onHide($event: any): void { }

    onBack($event: any): void {
        this.location.back();
    }

    updateAuditTarget(): void {
        this.submitAttempt = true;
        if (this.auditTargetsFormGroup.valid) {
            const formValue = this.auditTargetsFormGroup.value;
            this.companyService.updateCompanyAuditTarget(formValue).subscribe(
                response => {
                    this.alertMessage.showMessage();
                },
                error => {
                    this.errors = error.errorList;
                }
            );
        }
    }

}
